module.exports = __webpack_public_path__ + "img/phone.764a5d22.svg";